// src/data/cars.js
// Bundled fallback fleet. Once the admin portal is live, the site reads
// /data/cars.json instead and this file only matters if that file is missing.
//
// tier = which management fee class the car falls in (exotic | luxury | economy).
// The tier values below are PLACEHOLDERS until you decide where each car belongs.

import BlackPorsche911 from '../assets/BlackPorsche911.avif';
import lamboG from '../assets/lamboG.avif';
import sl550 from '../assets/sl550.avif';
import RedCamaro from '../assets/RedCamaro.avif';
import BigBlackMercedes from '../assets/BigBlackMercedes.avif';
import glc from '../assets/glc.avif';
import GrayDiscovery from '../assets/GrayDiscovery.avif';
import range from '../assets/range.avif';
import moodely from '../assets/modelygray.avif';
import atlas from '../assets/atlas.avif';
import hondapilot from '../assets/hondapilot.avif';
import santafesport from '../assets/santafesport.avif';
import jeepc from '../assets/jeepc.avif';
import redequinox from '../assets/redequinox.avif';
import blkequinox from '../assets/blkequinox.avif';
import sportage from '../assets/sportage.avif';
import mazdacx from '../assets/mazdacx.avif';
import priusImg from '../assets/prius.jpg';
import corollaImg from '../assets/corolla.jpg';
import BlackHyundai from '../assets/BlackHyundai.avif';
import cruze from '../assets/cruze.avif';
import focuss from '../assets/focuss.avif';

const cars = [
  {
    name: '2021 Porsche 911',
    image: BlackPorsche911,
    link: 'https://turo.com/us/en/car-rental/united-states/las-vegas-nv/porsche/911/2986754',
    tag: 'Exotic',
    tier: 'exotic',
  },
  {
    name: '2006 Lamborghini Gallardo',
    image: lamboG,
    link: 'https://turo.com/us/en/car-rental/united-states/las-vegas-nv/lamborghini/gallardo/2972354',
    tag: 'Exotic',
    tier: 'exotic',
  },
  {
    name: '2013 Mercedes-Benz SL-Class',
    image: sl550,
    link: 'https://turo.com/us/en/car-rental/united-states/las-vegas-nv/mercedes-benz/sl-class/1992352',
    tag: 'Luxury Convertible',
    tier: 'luxury',
  },
  {
    name: '2023 Chevrolet Camaro',
    image: RedCamaro,
    link: 'https://turo.com/us/en/car-rental/united-states/las-vegas-nv/chevrolet/camaro/3630039',
    tag: 'Convertible',
    tier: 'economy',
  },
  {
    name: '2021 Mercedes-Benz GLE-Class',
    image: BigBlackMercedes,
    link: 'https://turo.com/us/en/suv-rental/united-states/las-vegas-nv/mercedes-benz/gle-class/3624768',
    tag: 'Luxury SUV',
    tier: 'luxury',
  },
  {
    name: '2017 Mercedes-Benz GLC-Class',
    image: glc,
    link: 'https://turo.com/us/en/suv-rental/united-states/las-vegas-nv/mercedes-benz/glc-class/2938666',
    tag: 'Luxury SUV',
    tier: 'luxury',
  },
  {
    name: '2019 Land Rover Discovery Sport',
    image: GrayDiscovery,
    link: 'https://turo.com/us/en/suv-rental/united-states/las-vegas-nv/land-rover/discovery-sport/3623903',
    tag: 'Luxury SUV',
    tier: 'luxury',
  },
  {
    name: '2015 Land Rover Range Rover Evoque',
    image: range,
    link: 'https://turo.com/us/en/suv-rental/united-states/las-vegas-nv/land-rover/range-rover-evoque/2517913',
    tag: 'Luxury SUV',
    tier: 'luxury',
  },
  {
    name: '2026 Tesla Model Y',
    image: moodely,
    link: 'https://turo.com/us/en/suv-rental/united-states/las-vegas-nv/tesla/model-y/3497357',
    tag: 'EV',
    tier: 'economy',
  },
  {
    name: '2025 Volkswagen Atlas',
    image: atlas,
    link: 'https://turo.com/us/en/suv-rental/united-states/las-vegas-nv/volkswagen/atlas/3237176',
    tag: 'SUV',
    tier: 'economy',
  },
  {
    name: '2018 Honda Pilot',
    image: hondapilot,
    link: 'https://turo.com/us/en/suv-rental/united-states/las-vegas-nv/honda/pilot/2991051',
    tag: 'SUV',
    tier: 'economy',
  },
  {
    name: '2017 Hyundai Santa Fe Sport',
    image: santafesport,
    link: 'https://turo.com/us/en/suv-rental/united-states/las-vegas-nv/hyundai/santa-fe-sport/2974874',
    tag: 'SUV',
    tier: 'economy',
  },
  {
    name: '2017 Jeep Cherokee',
    image: jeepc,
    link: 'https://turo.com/us/en/suv-rental/united-states/las-vegas-nv/jeep/cherokee/2572736',
    tag: 'SUV',
    tier: 'economy',
  },
  {
    name: '2018 Chevrolet Equinox',
    image: redequinox,
    link: 'https://turo.com/us/en/suv-rental/united-states/las-vegas-nv/chevrolet/equinox/2975934',
    tag: 'SUV',
    tier: 'economy',
  },
  {
    name: '2014 Chevrolet Equinox',
    image: blkequinox,
    link: 'https://turo.com/us/en/suv-rental/united-states/las-vegas-nv/chevrolet/equinox/2541848',
    tag: 'SUV',
    tier: 'economy',
  },
  {
    name: '2015 Kia Sportage',
    image: sportage,
    link: 'https://turo.com/us/en/suv-rental/united-states/las-vegas-nv/kia/sportage/2519745',
    tag: 'SUV',
    tier: 'economy',
  },
  {
    name: '2022 Mazda CX-30',
    image: mazdacx,
    link: 'https://turo.com/us/en/suv-rental/united-states/las-vegas-nv/mazda/cx-30/3056303',
    tag: 'Crossover',
    tier: 'economy',
  },
  {
    name: '2024 Toyota Prius',
    image: priusImg,
    link: 'https://turo.com/us/en/car-rental/united-states/las-vegas-nv/toyota/prius/2927742',
    tag: 'Hybrid',
    tier: 'economy',
  },
  {
    name: '2021 Toyota Corolla',
    image: corollaImg,
    link: 'https://turo.com/us/en/car-rental/united-states/las-vegas-nv/toyota/corolla/3136636',
    tag: 'Sedan',
    tier: 'economy',
  },
  {
    name: '2022 Hyundai Elantra',
    image: BlackHyundai,
    link: 'https://turo.com/us/en/car-rental/united-states/las-vegas-nv/hyundai/elantra/3625548',
    tag: 'Sedan',
    tier: 'economy',
  },
  {
    name: '2018 Chevrolet Cruze',
    image: cruze,
    link: 'https://turo.com/us/en/car-rental/united-states/las-vegas-nv/chevrolet/cruze/3261619',
    tag: 'Sedan',
    tier: 'economy',
  },
  {
    name: '2017 Ford Focus',
    image: focuss,
    link: 'https://turo.com/us/en/car-rental/united-states/las-vegas-nv/ford/focus/3258749',
    tag: 'Sedan',
    tier: 'economy',
  },
];

export default cars;
